import { atom } from "recoil";

export const userState = atom({
  key: "userState",
  default: null,
});

export const activeNavState = atom({
  key: "activeNavState",
  default: "todos",
});

export const employeeSearchBarState = atom({
  key: "employeeSearchBarState",
  default: "",
});

export const loginResponseState = atom({
  key: "loginResponseState",
  default: "",
});

export const attendanceFilterState = atom({
  key: "attendanceFilterState",
  default: "",
});

export const attendanceDateState = atom({
  key: "attendanceDateState",
  default: "today",
});

export const attendanceModalState = atom({
  key: "attendanceModalState",
  default: false,
});

export const attendanceEmpModalIdState = atom<any>({
  key: "attendanceEmpModalIdState",
  default: 0,
});

export const modalOpenState = atom<boolean>({
  key: "modalOpenState",
  default: false,
});

export const empMonthCardIdState = atom<any>({
  key: "empMonthCardIdState",
  default: 0,
});

export const totalPresentDaysState = atom({
  key: "totalPresentDaysState",
  default: 0,
});

export const holidayState = atom({
  key: "holidayState",
  default: parseFloat(localStorage.getItem("holiday") ?? "0"),
});

export const holidayDatesState = atom({
  key: "holidayDatesState",
  default: localStorage.getItem("holidayDates") ?? "",
});

export const modalTitle = atom({
  key: "modalTitle",
  default: "",
});

export const toastShowState = atom({
  key: "toastShowState",
  default: false,
});

export const toastBgState = atom({
  key: "toastBgState",
  default: "",
});

export const toastMessageState = atom({
  key: "toastMessageState",
  default: "",
});

export const toastAutoHideState = atom({
  key: "toastAutoHideState",
  default: true,
});

export const salaryModalTitleState = atom({
  key: "salaryModalTitle",
  default: "",
});

export const isBulkSalaryUpdatedState = atom({
  key: "isBulkSalaryUpdated",
  default: false,
});

export const isBulkInventoryUpdatedState = atom({
  key: "isBulkInventoryUpdated",
  default: false,
});

export const isBulkInventoryAddedState = atom({
  key: "isBulkInventoryAdded",
  default: false,
});

export const isFileDownloadingState = atom({
  key: "isFileDownloadingState",
  default: false,
});

export const inventorySearchState = atom({
  key: "inventorySearchState",
  default: "",
});

export const inventoryModalTitleState = atom({
  key: "inventoryModalTitle",
  default: "",
});

export const inventoryEntryPartIdState = atom({
  key: "inventoryEntryPartIdState",
  default: 1,
});

export const incomingHistoryPartyState = atom({
  key: "incomingHistoryPartyState",
  default: 0,
});

export const incomingChallanItemState = atom({
  key: "incomingChallanItemState",
  default: 0,
});

export const InOutModalTitleState = atom({
  key: "InOutModalTitle",
  default: "",
});

export const incomingItemsModalTitleState = atom({
  key: "incomingItemsModalTitleState",
  default: "",
});

export const invResetFieldsState = atom({
  key: "invResetFieldsState",
  default: false,
});

export const inOutResetFieldsState = atom({
  key: "inOutResetFieldsState",
  default: false,
});

export const incomingItemsResetFieldsState = atom({
  key: "incomingItemsResetFieldsState",
  default: false,
});

export const locationPartyEditIdState = atom({
  key: "locationPartyEditIdState",
  default: 0,
});

export const locationPartyEditState = atom({
  key: "locationPartyEditState",
  default: "",
});

export const inOutMonthFilterState = atom({
  key: "inOutMonthFilterState",
  default: "current",
});

export const inOutMonthCustomFilterState = atom({
  key: "inOutMonthCustomFilterState",
  default: "",
});

export const incomingItemsMonthFilterState = atom({
  key: "incomingItemsMonthFilterState",
  default: "current",
});

export const incomingItemsMonthCustomFilterState = atom({
  key: "incomingItemsMonthCustomFilterState",
  default: "",
});

export const inventoryItemAdditionalState = atom({
  key: "inventoryItemAdditionalState",
  default: 0,
});

export const toggleBarcodeSearchState = atom({
  key: "toggleBarcodeSearchState",
  default: false,
});

export const selectedBarcodeHistoryState = atom({
  key: "selectedBarcodeHistoryState",
  default: "",
});

export const bulkCostingModalTitleState = atom({
  key: "bulkCostingModalTitleState",
  default: "",
});
